/**
 * @author Umer Hassan
 * @desc filters for the filter panel on the single publication page
 * @example <refine-date-picker start-date="$ctrl.filters.startDate.value"
 *                              update-start-date="$ctrl.updateStartDate(date)">
 *          </refine-date-picker>
 */

import template from './refineDatePicker.html';

class RefineDatePickerController {
  constructor(moment) {
    this.moment = moment;
  }

  $onInit() {
    this.datePickerOptions = {
      showWeeks: false,
      dateDisabled: this.validateDates(),
      minDate: this.availableEditions ? this.moment(this.minDate).toDate() : null
    };

    if (!this.startDate && !this.availableEditions) {
      this.updateStartDate({ date: this.moment().unix() });
    }
  }

  $onChanges() {
    if (this.startDate) {
      this.dateSelected = +this.moment.unix(this.startDate);
      this.date = this.dateSelected;
    }
  }

  updateSelectedDate(date) {
    const newStartDate = this.availableEditions ? +this.moment(date) :
      +this.moment(date).startOf('day');
    this.updateStartDate({ date: this.moment(newStartDate).unix() });
    this.dateSelected = newStartDate;
  }

  // To manually close dropdown on update button click
  toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  update(event) {
    const date = this.availableEditions ? this.availableEditions.find(editionTime =>
      +this.moment(editionTime).startOf('day') === +this.moment(this.date).startOf('day')) :
      this.date;
    this.updateSelectedDate(date);
    this.toggleDropdown(event);
  }

  today(event) {
    this.updateSelectedDate(+this.moment());
    this.toggleDropdown(event);
  }

  validateDates() {
    if (this.availableEditions) {
      return (dateObj) => {
        const currentDate = +this.moment(dateObj.date).startOf('day');
        return !this.availableEditions.some(val => currentDate === +this.moment(val).startOf('day'));
      };
    }
    return null;
  }
}

RefineDatePickerController.$inject = ['moment'];

const component = {
  template,
  bindings: {
    startDate: '<',
    updateStartDate: '&',
    minDate: '<',
    availableEditions: '<'
  },
  controller: 'RefineDatePickerController'
};

export default function (ngModule) {
  ngModule.component('refineDatePicker', component);
  ngModule.controller('RefineDatePickerController', RefineDatePickerController);
}
